import { z } from 'zod'
import { dateOrIsoString } from '~/prix/types/date'
import sql from '~/prix/utils/sql'

export const clientObject = z.object({
  id: z.number().int().positive(),
  name: z.string(),
  cnpj: z.string().nullish(),
  cnes: z.string().nullish(),
  kind: z.enum([
    'municipalHealthSecretariat',
    'stateHealthSecretariat',
    'nationalHealthMinistry',
    'regionalAlliance',
    'communityHospital',
    'publicHospital',
    'privateHospital',
    'mock',
    'civilPolice',
    'federalPolice',
    'militaryPolice',
  ]),
  municipalityId: z.number().int().nullish(),
  stateId: z.number().int().nullish(),
  countryId: z.number().int().nullish(),
  createdAt: dateOrIsoString().nullish(),
  updatedAt: dateOrIsoString().nullish(),
  deletedAt: dateOrIsoString().nullish(),
  abbreviation: z.string().nullish(),
})

export type ClientType = z.infer<typeof clientObject>

export const propertyMap = {
  id: sql`id`,
  name: sql`name`,
  cnpj: sql`cnpj`,
  cnes: sql`cnes`,
  kind: sql`kind`,
  municipalityId: sql`municipality_id`,
  stateId: sql`state_id`,
  countryId: sql`country_id`,
  createdAt: sql`created_at`,
  updatedAt: sql`updated_at`,
  deletedAt: sql`deleted_at`,
  abbreviation: sql`abbreviation`,
}
